import { createSlice } from '@reduxjs/toolkit';
import { brandRelevant } from './brandAsyncThunk';

const brandRelevantSlice = createSlice({
  name: "brand",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [brandRelevant.pending]: (state, action) => {
      state.payload = [];
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [brandRelevant.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [brandRelevant.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default brandRelevantSlice.reducer;